import axios from "axios";
import baseURL from "../configs/api";

export const post_Quote = async (data: any, userId: number, tenantId: string) => {
    const response = await axios({
        url: `${baseURL}quote?userId=${userId}`,
        method: "POST",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data
    });
    return response.data;
}

export const confirm_Quote = (data: any, userId: number, tenantId: string) => {
    return axios({
        url: `${baseURL}quote/ConfirmQuote?userId=${userId}`,
        method: "POST",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data
    }).then(response => response.data);
}


export const put_Quote = async (data: any, userId: number, tenantId: string) => {
    const response = await axios({
        url: `${baseURL}quote?userId=${userId}`,
        method: "PUT",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data
    });
    return response.data;
}

export const getQuotePdfSummary = (primaryKey: string, tenantId: string) => {
    return getFetch(`quote/GetQuotePdfSummary/${primaryKey}`, tenantId);
}

export const getQuote = (primaryKey: number, tenantId: string) => {
    return getFetch(`quote/GetQuote/${primaryKey}`, tenantId);
}

const getFetch = (url: string, tenantId: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        params: params
    }).then(response => response.data);
}